let positionFetchFromWatch = true;

export const setPositionFetchFromWatch = (value: boolean) => {
  positionFetchFromWatch = value;
};

export const getPositionFetchFromWatch = () => positionFetchFromWatch;

let backgroundLocationWatch = false;

export const setBackgroundLocationWatch = (value: boolean) => {
  backgroundLocationWatch = value;
};

export const getBackgroundLocationWatch = () => backgroundLocationWatch;

let debugLocationAlerts = false;

export const setDebugLocationAlerts = (value: boolean) => {
  debugLocationAlerts = value;
};

export const debugAlert = (message: string) => {
  if (debugLocationAlerts) alert(message);
};
